import React, { useCallback } from "react";
import { useForm } from "react-hook-form";
import { InserirCategoriaAtendimentoController } from "../../../../../../../Controllers/Geral/CategoriaAtendimento/CategoriaAtendimentoController";
import { ICategoriaAtendimento } from "../../../../../../../Interfaces/Geral/GestaoDeCadastro/CategoriaAtendimento/CategoriaAtendimentoInterface";
import SelectCategoriaAtendimento from "../../../../../../CardsPages/Forms/SelectCategoriaAtendimento";

interface ICadastrarCategoriaProps {
    updateList: () => void;
    setShow: (show: boolean) => void;
}

export default function CadastrarCategoria(props: ICadastrarCategoriaProps) {
    const { register, handleSubmit, formState, reset, control } =
        useForm<ICategoriaAtendimento>();
    const { setShow, updateList } = props;

    const onSubmit = useCallback(
        (formData: ICategoriaAtendimento) => {
            InserirCategoriaAtendimentoController(formData).then((res) => {
                reset();
                setShow(false);
                updateList();
            });
        },
        [setShow, updateList, reset]
    );

    return (
        <>
            <div className="text-center mb-10 mb-lg-20">
                <h2 className="font-weight-bold">Cadastro de Categoria</h2>
            </div>
            <form className="form row" onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group border-bottom py-3 b-5 col-12">
                    <input
                        className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                            formState.errors.DS_CATEGORIA_ATENDIMENTO &&
                            "is-invalid"
                        }`}
                        type="text"
                        placeholder="Nome da Categoria"
                        name="DS_CATEGORIA_ATENDIMENTO"
                        ref={register({
                            required: "Insira o nome do categoria",
                        })}
                        autoComplete="off"
                    />
                    <div className="invalid-feedback">
                        {formState.errors.DS_CATEGORIA_ATENDIMENTO
                            ? formState.errors.DS_CATEGORIA_ATENDIMENTO.message
                            : ""}
                    </div>
                </div>
                <div className="form-group py-3 b-5 col-12 col-sm-6">
                    <label>Categoria Pai</label>
                    <SelectCategoriaAtendimento
                        control={control}
                        name="ID_CATEGORIA_ATENDIMENTO_PAI"
                    />
                    <div className="invalid-feedback">
                        {formState.errors.ID_CATEGORIA_ATENDIMENTO_PAI
                            ? formState.errors.ID_CATEGORIA_ATENDIMENTO_PAI
                                  .message
                            : ""}
                    </div>
                </div>
                <div className="form-group py-3 b-5 col-12 col-sm-6">
                    <label>SLA (horas)</label>
                    <input
                        className={`form-control ${
                            formState.errors.NR_SLA && "is-invalid"
                        }`}
                        type="number"
                        name="NR_SLA"
                        ref={register()}
                    />
                    <div className="invalid-feedback">
                        {formState.errors.NR_SLA
                            ? formState.errors.NR_SLA.message
                            : ""}
                    </div>
                </div>
                <div className="form-group py-3 b-5 col-12 col-sm-6">
                    <label>Garantia (meses)</label>
                    <input
                        className={`form-control ${
                            formState.errors.NR_GARANTIA_MESES && "is-invalid"
                        }`}
                        type="number"
                        name="NR_GARANTIA_MESES"
                        ref={register()}
                    />
                    <div className="invalid-feedback">
                        {formState.errors.NR_GARANTIA_MESES
                            ? formState.errors.NR_GARANTIA_MESES.message
                            : ""}
                    </div>
                </div>
                <div className="form-group py-3 b-5 col-12 col-sm-6">
                    <label>Código UAU</label>
                    <input
                        className={`form-control ${
                            formState.errors.ID_CHAVE_ERP && "is-invalid"
                        }`}
                        type="text"
                        name="ID_CHAVE_ERP"
                        ref={register()}
                    />
                    <div className="invalid-feedback">
                        {formState.errors.ID_CHAVE_ERP
                            ? formState.errors.ID_CHAVE_ERP.message
                            : ""}
                    </div>
                </div>
                <div className="mb-5 w-100 row no-gutters">
                    <div className="col-6 d-flex flex-column align-itens-center justify-content-center">
                        <div className="text-center font-weight-bold">
                            Abertura ativa no portal:
                        </div>
                        <span
                            className="switch switch-outline switch-sm switch-icon switch-info d-flex justify-content-center"
                            data-toggle="tooltip"
                        >
                            <label>
                                <input
                                    id="FL_ATIVO_PORTAL_STATUS"
                                    name="FL_ATIVO_PORTAL"
                                    defaultChecked={false}
                                    ref={register()}
                                    type="checkbox"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                    <div className="col-6 d-flex flex-column align-itens-center justify-content-center">
                        <div className="text-center font-weight-bold">
                            Limitar a um Atendimento por Cliente - Produto:
                        </div>
                        <span
                            className="switch switch-outline switch-sm switch-icon switch-warning d-flex justify-content-center"
                            data-toggle="tooltip"
                        >
                            <label>
                                <input
                                    id="FL_BLOCK_ABERTURA_ATENDIMENTO_CONTA_PRODUTO_CATEGORIA_STATUS"
                                    name="FL_BLOCK_ABERTURA_ATENDIMENTO_CONTA_PRODUTO_CATEGORIA"
                                    defaultChecked={false}
                                    ref={register()}
                                    type="checkbox"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
                <div className="d-flex flex-wrap justify-content-center align-items-center col-12">
                    <button
                        type="submit"
                        className="btn btn-capys font-weight-bold px-9 py-4 my-2"
                    >
                        Cadastrar
                    </button>
                </div>
            </form>
        </>
    );
}
